import { LeaderboardReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: LeaderboardReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const leaderboardReducer = createReducer(initialState, {
  GET_LEADERBOARD_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_LEADERBOARD_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_LEADERBOARD_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
});

export default leaderboardReducer;
